import axios from "axios";
import { toast } from "react-toastify";
import { API, Endpoints } from "./Constants";
import { getAuthString, removeEmptyValues, reverseObject } from "./Utilities";



export const ServerAPI = {
  APIMethod: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
  },

  settingsData: async () => {
    return ServerAPI.executeAPI(API.EndPoint.settings, ServerAPI.APIMethod.GET, true);
  },
  productData: async (filters) => {
    let data = {};
    data = filters;
    return ServerAPI.executeAPI(API.EndPoint.loanProducts, ServerAPI.APIMethod.POST, true, data);
  },
  createLoan: async (loanDetails) => {
    let data = {};
    data = loanDetails;
    return ServerAPI.executeAPI(API.EndPoint.createLoan, ServerAPI.APIMethod.POST, true, data);
  },

  fileUpload: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', 'loan_application');
    return ServerAPI.executeAPI(API.EndPoint.uploadImage, ServerAPI.APIMethod.POST, true, formData, null, false, false, true);
  },
  flooringFileUpload: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', 'flooring_application');
    return ServerAPI.executeAPI(API.EndPoint.flooringDocument, ServerAPI.APIMethod.POST, true, formData, null, false, false, true);
  },
  updateApplication: async (updateDataKey, guarantorData) => {
    let data = {};
    if (updateDataKey == 'applicant_type') {
      let dataValue = JSON.parse(localStorage.getItem('applicant_details'));
      if (dataValue) {
        dataValue = reverseObject(dataValue);
        dataValue["applicant_type"] = guarantorData;
        data['applicant_details'] = dataValue;
      } else {
        data['applicant_details'] = {
          "applicant_type": guarantorData
        }
      }
    }
    if (updateDataKey == 'applicant_documents') {
      let dataValue = JSON.parse(localStorage.getItem('applicant_documents'));
      data[updateDataKey] = {
        ...dataValue,
        ['applicant_signature']: dataValue?.applicant_signature?.value ? dataValue?.applicant_signature?.value : '',
        ['company_stamp']: dataValue?.company_stamp?.value ? dataValue?.company_stamp?.value : ''
      };
    }
    if (updateDataKey == 'vehicle_details') {
      let dataValue = JSON.parse(localStorage.getItem('vehicleDetails'));
      let vehDoc = JSON.parse(localStorage.getItem('vehicleDocuments'));
      dataValue = reverseObject(dataValue);
      let finalDataValue = {
        ...dataValue,
        ...vehDoc
      };
      data[updateDataKey] = finalDataValue;

    }
    if (updateDataKey == 'applicant_declaration') {
      data[updateDataKey] = JSON.parse(localStorage.getItem('declarationDetails'));
    } if (updateDataKey == 'applicant_details') {
      data[updateDataKey] = JSON.parse(localStorage.getItem('applicant_details'));
      data['applicant_employement_details'] = JSON.parse(localStorage.getItem('applicant_employement_details'));
      data = (reverseObject(data));
      let updateData = removeEmptyValues(data['applicant_details']);
      console.log("updateData", updateData);
      updateData['applicant_type'] = localStorage.getItem('applicanttypeid');
      data['applicant_details'] = updateData;
      console.log(data, updateData, '000000000000000000))))))))))))))))))))')
      data['applicant_employement_details'] = removeEmptyValues(data['applicant_employement_details']);
    } if (updateDataKey == 'guarantor' && guarantorData) {
      data['guarantor_details'] = [guarantorData];
    } if (updateDataKey == 'guarantor_details' && guarantorData) {
      data[updateDataKey] = guarantorData;
      console.log(data, guarantorData, '}}}}}}}}}}}}}}}}}}}}}}}}}}}')
    } if (updateDataKey == 'applicant_declaration') {
      let dataValue = JSON.parse(localStorage.getItem('declarationDetails'))
      // data[updateDataKey] = reverseObject(dataValue);
      // let reversed = reverseObject(dataValue);
      // let formData = {
      //   ...(reversed.form_data?.value || {}),
      //   ...Object.fromEntries(
      //     Object.entries(reversed).filter(([k]) => k !== "form_data")
      //   )
      // };
      let formData = Object.fromEntries(
        Object.entries(dataValue)
          .filter(([k]) => k !== "form_data") 
          .map(([k, v]) => [k, v])            
      );
      if (dataValue.form_data?.value) {
        Object.assign(formData, dataValue.form_data.value);
      }
      data['applicant_declaration'] = { form_data: formData };
      
    } if (updateDataKey == 'signature' && guarantorData) {
      data = guarantorData;
    }
    return ServerAPI.executeAPI(API.EndPoint.updateApplication + "/" + localStorage.getItem("applicationno"), ServerAPI.APIMethod.POST, true, data);
  },

  getApplication: async () => {
    return ServerAPI.executeAPI(API.EndPoint.applicationInfo + localStorage.getItem("applicationno"), ServerAPI.APIMethod.GET, true);
  },
  getApplicationWithoutToken: async () => {
    return ServerAPI.executeAPI(API.EndPoint.applicationInfoWithoutToken + "/" + localStorage.getItem("applicationno"), ServerAPI.APIMethod.GET, false);
  },
  getLoanTypes: async (categoryId, typeId) => {
    return ServerAPI.executeAPI(API.EndPoint.loanTypes + "/" + categoryId + "/" + typeId, ServerAPI.APIMethod.GET, true);
  },
  nricVerifier: async (value) => {
    let data = {};
    data['nric'] = value;
    data['application'] = localStorage.getItem('applicationno') ? localStorage.getItem('applicationno') : "";
    data['verification_type'] = localStorage.getItem('holderType') ? localStorage.getItem('holderType') : "";
    data['guarantor_id'] = localStorage.getItem('holderId') ? localStorage.getItem('holderId') : "";
    return ServerAPI.executeAPI(API.EndPoint.nricverifier, ServerAPI.APIMethod.POST, false, data);
  },
  signatureVerifier: async (dataValues) => {
    let data = {};
    data = dataValues;
    return ServerAPI.executeAPI(API.EndPoint.signatureverifier, ServerAPI.APIMethod.POST, false, data);
  },

  previewLoanApplicantion: async (productId, holderId) => {
    console.log(holderId);
    if (holderId != '' && holderId != undefined) {
      return ServerAPI.executeAPI(API.EndPoint.previewApplication + "/" + localStorage.getItem('applicationno') + "/" + productId + "/" + holderId, ServerAPI.APIMethod.GET, false);
    } else {
      return ServerAPI.executeAPI(API.EndPoint.previewApplication + "/" + localStorage.getItem('applicationno') + "/" + productId, ServerAPI.APIMethod.GET, false);
    }
  },
  updateLoanApplicationTypeInfo: async (dataValues) => {
    let data = {};
    data = dataValues;
    return ServerAPI.executeAPI(API.EndPoint.updateLoanType + "/" + localStorage.getItem('applicationno'), ServerAPI.APIMethod.POST, true, data);
  },
  completeLoanApplication: async (dataValues) => {
    let data = {};
    data = dataValues;
    return ServerAPI.executeAPI(API.EndPoint.completeLoanApplication + "/" + localStorage.getItem('applicationno'), ServerAPI.APIMethod.POST, true, data);
  },
  getCart: async () => {
    return ServerAPI.executeAPI(API.EndPoint.getcartItems, ServerAPI.APIMethod.GET, true);
  },
  updateCart: async (dataValues) => {
    let data = {};
    data['items'] = dataValues;
    return ServerAPI.executeAPI(API.EndPoint.updatecartItems, ServerAPI.APIMethod.PUT, true, data);
  },
  RemoveCart: async () => {
    return ServerAPI.executeAPI(API.EndPoint.clearcartItems, ServerAPI.APIMethod.DELETE, true, null);
  },
  applicationList: async (filters, Page, size) => {
    let data = {};
    data = filters;
    return ServerAPI.executeAPI(`${API.EndPoint.applicationList}/${size}/${Page}`, ServerAPI.APIMethod.POST, true, data);
  },
  applicationInfo: async () => {
    return ServerAPI.executeAPI(API.EndPoint.applicationInfo + localStorage.getItem('applicationId'), ServerAPI.APIMethod.GET, true);
  },


  executeAPI: async (
    endpoint,
    method,
    authRequired,
    data,
    params,
    suppressError,
    returnError,
    fileUpload
  ) => {
    let headers = {};

    if (authRequired) {
      const persistAuthString = await getAuthString();
      if (persistAuthString) {
        headers["Authorization"] = `Bearer ${persistAuthString}`
      }
    }

    if ((method === "POST" || method === "PUT") && !fileUpload) {
      headers["Content-Type"] = "application/json";
    } else if ((method === "POST" || method === "PUT") && fileUpload) {
      headers["Content-Type"] = "multipart/form-data";
    }


    try {
      const response = await axios({
        method: method,
        url: API.BaseUrl + endpoint,
        data: !fileUpload ? JSON.stringify(data) : data,
        headers: headers,
        params: params,
      });
      return response.data;
    } catch (error) {
      if (
        axios.isAxiosError(error) &&
        error.response &&
        !suppressError &&
        !returnError
      ) {
        const errorData = error.response.data;
        if (errorData.errors && errorData.errors.length > 0) {
          if (errorData.errors) {
            toast.error(errorData.errors);
          } else {
            toast.error(errorData.errors);
          }
        } else {
          // toast.error("Error Occurred in the Request!");
        }
      }

      if (axios.isAxiosError(error) && error.response && returnError) {
        const errorData = error.response.data;
        if (errorData.errors && errorData.errors.length > 0) {
          if (errorData.errors) {
            return errorData.errors;
          }
        } else {
          // toast.error("Error Occurred in the Request!");
        }
      }
    }
  }
}
